import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  AircraftEventSkeleton,
  PagedAircraftEventAudit,
  PagedAircraftEventBusinessPersonAudit,
  PagedScheduledEventAudit
} from './+models/aircraft-event-audit.model';

@Injectable()
export class AircraftEventAuditService {
  private readonly apiUrl = '/sdapi/pre-flight/AircraftEventAudit';

  constructor(private readonly http: HttpClient) {}

  getAircraftEventSkeletons() {
    const url = `${this.apiUrl}/AircraftEventSkeletons`;
    return this.http.get<AircraftEventSkeleton[]>(url);
  }

  getAircraftEventAudits(
    aircraftEventId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 10;
    }
    let url = `${this.apiUrl}/${aircraftEventId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedAircraftEventAudit>(url);
  }

  getAircraftEventBusinessPersonAudits(
    aircraftEventBusinessPersonId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 10;
    }
    let url = `${this.apiUrl}/AircraftEventBusinessPerson/${aircraftEventBusinessPersonId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedAircraftEventBusinessPersonAudit>(url);
  }

  getScheduledEventAudits(
    scheduledEventId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 10;
    }
    let url = `${this.apiUrl}/ScheduledEvent/${scheduledEventId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedScheduledEventAudit>(url);
  }
}
